import React, { useState, useEffect } from "react";
import { getChat } from "../Api";
import secureLocalStorage from "react-secure-storage";
import Modal from "react-modal";
import { typingSet } from "../services/constants";
import {
  preventionFAQs,
  preopFAQs,
  postopFAQs_1stQ,
  postopFAQs_2ndQ,
  postopFAQs_3rdQ,
} from "../services/constants";

const AskJane = ({ surgeryStatus, weekNo }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const [typingMessage, setTypingMessage] = useState("");
  const [seeAllModalIsOpen, setSeeAllModalIsOpen] = useState(false);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    // const patientInfo = secureLocalStorage.getItem("patient_info");
    // const weekNo = secureLocalStorage.getItem("week_no");

    // if (patientInfo) {
    if (surgeryStatus) {
      if (surgeryStatus === "Prevention") {
        setQuestions(preventionFAQs);
      } else if (surgeryStatus === "Pre-Op") {
        setQuestions(preopFAQs);
      } else if (surgeryStatus === "Post-Op") {
        if (weekNo >= 1 && weekNo <= 4) {
          setQuestions(postopFAQs_1stQ);
        } else if (weekNo >= 5 && weekNo <= 12) {
          setQuestions(postopFAQs_2ndQ);
        } else {
          setQuestions(postopFAQs_3rdQ);
        }
      }
      // }
    }
  }, [surgeryStatus]);

  const openModal = async (question) => {
    setCurrentQuestion(question);
    setIsOpen(true);
    setIsTyping(true);

    const selectedSet = typingSet[Math.floor(Math.random() * typingSet.length)];
    let messageIndex = 0;
    const lastMessageIndex = selectedSet.length - 1;

    function updateLoadingMessage() {
      if (messageIndex < lastMessageIndex) {
        setTypingMessage(selectedSet[messageIndex]);
        messageIndex++;

        const randomInterval = Math.random() * 1500 + 3000;
        setTimeout(updateLoadingMessage, randomInterval);
      }
    }

    updateLoadingMessage();

    try {
      const response = await getChat({
        topic: question,
        patientId: secureLocalStorage.getItem("patient_id"),
        history: [{ role: "user", content: question }],
        personality: "NURSE_PERSONALITY",
        session_id: Math.random().toString(36).substring(2, 15),
      });
      const janeMessage = { role: "ai", content: response.message };
      setChatHistory([janeMessage]);
    } catch (error) {
      console.error("Error fetching chat response:", error);
    } finally {
      setIsTyping(false);
    }
  };

  const closeModal = () => {
    setIsOpen(false);
    setChatHistory([]);
    setCurrentQuestion("");
  };

  const openSeeAllModal = () => {
    setSeeAllModalIsOpen(true);
  };

  const closeSeeAllModal = () => {
    setSeeAllModalIsOpen(false);
  };

  const handleQuestionClick = (question) => {
    closeSeeAllModal();
    openModal(question);
  };

  return (
    <section className="ask-jane-section">
      <div className="ask-jane-header">
        <h3>Ask Jane</h3>
        <button className="ask-jane-see-all" onClick={openSeeAllModal}>
          See All &gt;
        </button>
      </div>
      <ul>
        {questions.slice(0, 4).map((question, index) => (
          <li key={index} onClick={() => openModal(question)}>
            {question}
          </li>
        ))}
      </ul>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Ask Jane Modal"
        className="ask-jane-modal"
      >
        <div className="modal-container askjane-modal fade-fast">
          <div className="back-btn-container flex gap-10" onClick={closeModal}>
            <img src="../backButton.svg" alt="back" className="back-btn" /> Back
          </div>
          <h3 className="ask-jane-modal-heading">Ask Jane</h3>
          <div className="chat-box">
            <div className="chat-bubble user-bubble">
              <div>
                <p>{currentQuestion}</p>
              </div>
            </div>
            {isTyping && (
              <div className="chat-bubble jane-bubble typing-indicator">
                <p>{typingMessage}</p>
              </div>
            )}
            {chatHistory.map((message, index) => (
              <div key={index} className="chat-bubble jane-bubble">
                <div>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: message.content.replace(
                        /\*\*(.*?)\*\*/g,
                        "<b>$1</b>"
                      ),
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
          <button className="close-button" onClick={closeModal}>
            Done
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={seeAllModalIsOpen}
        onRequestClose={closeSeeAllModal}
        contentLabel="See All Questions Modal"
        className="ask-jane-modal"
      >
        <div className="modal-container askjane-see-all-modal fade-fast">
          <div
            className="back-btn-container flex gap-10"
            onClick={closeSeeAllModal}
          >
            <img src="../backButton.svg" alt="back" className="back-btn" /> Back
          </div>
          <h3 className="ask-jane-modal-heading">Ask Jane</h3>
          <p className="subheading">
            Not a doctor, but here to offer support you — like someone who’s
            been there.
          </p>
          <ul>
            {questions.map((question, index) => (
              <li key={index} onClick={() => handleQuestionClick(question)}>
                {question}
              </li>
            ))}
          </ul>
          <button className="close-button" onClick={closeSeeAllModal}>
            Close
          </button>
        </div>
      </Modal>
    </section>
  );
};

export default AskJane;
